import { useCallback } from 'react';

import { graphql, useMutation } from 'react-relay';

import type { DialogId } from '../analytics/types';
import type { Edition, Product } from '../types';

import type { useMarkDialogAsSeenMutation } from './__generated__/useMarkDialogAsSeenMutation.graphql';

/**
 * Unique key for dialogs having been auto opened
 */
export function dialogIdToKey(dialogId: DialogId, product: Product, edition: Edition) {
	return `edition-awareness:${dialogId}:${product}:${edition}:has-auto-opened`;
}

/**
 * Generic function to mark a dialog as having been seen by the user
 */
export function useMarkDialogAsSeen(): (
	dialogId: DialogId,
	product: Product,
	edition: Edition,
) => void {
	const [commit] = useMutation<useMarkDialogAsSeenMutation>(graphql`
		mutation useMarkDialogAsSeenMutation($key: String!, $value: String!) {
			setOnboardingState(states: [{ key: $key, value: $value }]) {
				value
			}
		}
	`);

	return useCallback(
		(dialogId: DialogId, product: Product, edition: Edition) => {
			commit({ variables: { key: dialogIdToKey(dialogId, product, edition), value: 'true' } });
			localStorage.setItem(dialogIdToKey(dialogId, product, edition), 'true');
		},
		[commit],
	);
}
